<main class="page-wrapper">
  <app-header id="top"></app-header>

  <section class="container my-5 pt-5 pb-lg-5">
    <div class="excluir-dados">
      <app-breadcrumbs [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs>

      <p class="excluir-dados__eyebrow text-light opacity-60 mb-2">{{ 'lgpd.eyebrow' | transloco }}</p>
      <h1 class="excluir-dados__title text-light mb-3">{{ 'lgpd.title' | transloco }}</h1>
      <p class="excluir-dados__lead text-light opacity-70 mb-4">
        {{ 'lgpd.lead' | transloco }}
        (<a href="mailto:contato@velzrentacar.com.br">contato@velzrentacar.com.br</a>).
      </p>

      <div class="excluir-dados__info mb-4">
        <h2 class="h5 text-light mb-3">{{ 'lgpd.important' | transloco }}</h2>
        <ul class="text-light opacity-80 mb-0">
          <li>{{ 'lgpd.free' | transloco }}</li>
          <li>{{ 'lgpd.deadline' | transloco }}</li>
          <li>{{ 'lgpd.retention' | transloco }}</li>
          <li>{{ 'lgpd.anpd' | transloco }} <a href="https://www.gov.br/anpd/" target="_blank" rel="noopener noreferrer">ANPD</a>.</li>
          <li><a [routerLink]="locale.localizePath('/politica-de-privacidade')">{{ 'lgpd.seePrivacy' | transloco }}</a></li>
        </ul>
      </div>

      <form class="excluir-dados__form needs-validation" novalidate [formGroup]="form" (ngSubmit)="enviar()">
        <fieldset class="excluir-dados__fieldset mb-4">
          <legend class="text-light fs-base mb-3">{{ 'lgpd.holder' | transloco }}</legend>

          <div class="mb-3">
            <label class="form-label text-light" for="lgpd-nome">{{ 'lgpd.fullName' | transloco }}</label>
            <input class="form-control form-control-light" id="lgpd-nome" type="text" formControlName="nome" autocomplete="name" [ngClass]="{'is-invalid': submitted && f['nome'].errors}">
            <div class="invalid-feedback">{{ 'lgpd.fullNameError' | transloco }}</div>
          </div>

          <div class="mb-3">
            <label class="form-label text-light" for="lgpd-cpf">{{ 'lgpd.cpf' | transloco }}</label>
            <input class="form-control form-control-light" id="lgpd-cpf" type="text" formControlName="cpf" placeholder="000.000.000-00" inputmode="numeric" autocomplete="off" (input)="maskCpf('cpf')" [ngClass]="{'is-invalid': submitted && f['cpf'].errors}">
            <div class="invalid-feedback">{{ 'lgpd.cpfError' | transloco }}</div>
          </div>

          <div class="mb-3">
            <label class="form-label text-light" for="lgpd-email">{{ 'lgpd.email' | transloco }}</label>
            <input class="form-control form-control-light" id="lgpd-email" type="email" formControlName="email" autocomplete="email" [ngClass]="{'is-invalid': submitted && f['email'].errors}">
            <div class="invalid-feedback">{{ 'lgpd.emailError' | transloco }}</div>
          </div>

          <div class="mb-0">
            <label class="form-label text-light" for="lgpd-telefone">{{ 'lgpd.phone' | transloco }}</label>
            <input class="form-control form-control-light" id="lgpd-telefone" type="tel" formControlName="telefone" placeholder="(99) 99999-9999" autocomplete="tel" (input)="maskTelefone()">
          </div>
        </fieldset>

        <fieldset class="excluir-dados__fieldset mb-4">
          <legend class="text-light fs-base mb-3">{{ 'lgpd.request' | transloco }}</legend>

          <div class="mb-3">
            <label class="form-label text-light" for="lgpd-direito">{{ 'lgpd.right' | transloco }}</label>
            <select class="form-select form-select-light" id="lgpd-direito" formControlName="direito" [ngClass]="{'is-invalid': submitted && f['direito'].errors}">
              @for (op of direitos; track op.value) {
                <option [value]="op.value">{{ 'lgpd.rights.' + op.value | transloco }}</option>
              }
            </select>
            <div class="invalid-feedback">{{ 'lgpd.rightError' | transloco }}</div>
          </div>

          <div class="mb-3">
            <label class="form-label text-light" for="lgpd-identificador">{{ 'lgpd.identifier' | transloco }}</label>
            <input class="form-control form-control-light" id="lgpd-identificador" type="text" formControlName="identificador" [placeholder]="'lgpd.identifierPlaceholder' | transloco">
          </div>

          <div class="mb-0">
            <label class="form-label text-light" for="lgpd-descricao">{{ 'lgpd.description' | transloco }}</label>
            <textarea class="form-control form-control-light" id="lgpd-descricao" rows="5" formControlName="descricao" [placeholder]="'lgpd.descriptionPlaceholder' | transloco" [ngClass]="{'is-invalid': submitted && f['descricao'].errors}"></textarea>
            <div class="invalid-feedback">{{ 'lgpd.descriptionError' | transloco }}</div>
          </div>
        </fieldset>

        <fieldset class="excluir-dados__fieldset mb-4">
          <legend class="text-light fs-base mb-2">{{ 'lgpd.representative' | transloco }}</legend>
          <p class="text-light opacity-60 small mb-3">{{ 'lgpd.representativeHint' | transloco }}</p>

          <div class="form-check form-check-light mb-3">
            <input class="form-check-input" type="checkbox" id="lgpd-rep" formControlName="tem_representante">
            <label class="form-check-label text-light" for="lgpd-rep">{{ 'lgpd.representativeCheck' | transloco }}</label>
          </div>

          @if (form.value.tem_representante) {
            <div class="mb-3">
              <label class="form-label text-light" for="lgpd-rep-nome">{{ 'lgpd.representativeName' | transloco }}</label>
              <input class="form-control form-control-light" id="lgpd-rep-nome" type="text" formControlName="representante_nome" [ngClass]="{'is-invalid': submitted && f['representante_nome'].errors}">
              <div class="invalid-feedback">{{ 'lgpd.representativeNameError' | transloco }}</div>
            </div>
            <div class="mb-3">
              <label class="form-label text-light" for="lgpd-rep-cpf">{{ 'lgpd.representativeCpf' | transloco }}</label>
              <input class="form-control form-control-light" id="lgpd-rep-cpf" type="text" formControlName="representante_cpf" placeholder="000.000.000-00" inputmode="numeric" (input)="maskCpf('representante_cpf')" [ngClass]="{'is-invalid': submitted && f['representante_cpf'].errors}">
              <div class="invalid-feedback">{{ 'lgpd.representativeCpfError' | transloco }}</div>
            </div>
            <div class="mb-0">
              <label class="form-label text-light" for="lgpd-rep-vinculo">{{ 'lgpd.relationship' | transloco }}</label>
              <input class="form-control form-control-light" id="lgpd-rep-vinculo" type="text" formControlName="representante_vinculo" [placeholder]="'lgpd.relationshipPlaceholder' | transloco" [ngClass]="{'is-invalid': submitted && f['representante_vinculo'].errors}">
              <div class="invalid-feedback">{{ 'lgpd.relationshipError' | transloco }}</div>
            </div>
          }
        </fieldset>

        <fieldset class="excluir-dados__fieldset mb-4">
          <legend class="text-light fs-base mb-3">{{ 'lgpd.declarations' | transloco }}</legend>

          <div class="form-check form-check-light mb-3">
            <input class="form-check-input" type="checkbox" id="lgpd-decl" formControlName="declaracao_titular" [ngClass]="{'is-invalid': submitted && f['declaracao_titular'].errors}">
            <label class="form-check-label text-light" for="lgpd-decl">{{ 'lgpd.declareHolder' | transloco }}</label>
            <div class="invalid-feedback">{{ 'lgpd.declareError' | transloco }}</div>
          </div>

          <div class="form-check form-check-light mb-0">
            <input class="form-check-input" type="checkbox" id="lgpd-art16" formControlName="ciencia_art16" [ngClass]="{'is-invalid': submitted && f['ciencia_art16'].errors}">
            <label class="form-check-label text-light" for="lgpd-art16">{{ 'lgpd.declareArt16' | transloco }}</label>
            <div class="invalid-feedback">{{ 'lgpd.declareError' | transloco }}</div>
          </div>
        </fieldset>

        @if (enviadoMsg) {
          <p class="text-success mb-3">{{ enviadoMsg }}</p>
        }
        @if (erroMsg) {
          <p class="text-danger mb-3">{{ erroMsg }}</p>
        }

        <div class="mb-4">
          <app-turnstile (tokenChange)="turnstileToken = $event"></app-turnstile>
        </div>

        <button class="btn btn-lg btn-primary" type="submit" [disabled]="enviando">
          {{ enviando ? ('common.sending' | transloco) : ('lgpd.submit' | transloco) }}
        </button>
      </form>
    </div>
  </section>
</main>

<app-footer></app-footer>
